import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Cookies from 'js-cookie';
import SaveModal from '../modal/saveModal';
import '../../common/css/serviceDetail.css';

function ScTicketDetail() {
    const [modalAction, setModalAction] = useState(null);
    const [modalContent, setModalContent] = useState(null);
    const [saveStatus, setSaveStatus] = useState(true);
    const [detailData, setDetailData] = useState(true);
    const [status, setStatus] = useState({
        0: '요청중',
        1: '접수완료',
        2: '접수불가(여정 불일치)',
        3: '접수불가(티켓/예약 조회불가))',
        4: '접수불가(AUTO REISSUE케이스 아님)',
        7: '기타',
    });

    // 서버통신
    useEffect(() => {
        const axiosData = async () => {
            try {
                const params = new URLSearchParams(window.location.search);
                const seq = params.get('seq') ?? 1;

                const hostname = window.location.hostname;
                let isLocal = null;
                if (hostname === 'wpal.philippineair.co.kr') {
            isLocal = true;
        } else {
            isLocal = false;
        }

                const response = await axios.get(
                    `${
                        isLocal
                            ? process.env.REACT_APP_PRODUCTION_API_URL
                            : process.env.REACT_APP_LOCAL_API_URL
                    }/wpal/board/scTicket/detail?seq=${seq}`,
                    {
                        withCredentials: true,
                    },
                );
                console.log(response.data);
                setDetailData(response.data);
            } catch (error) {
                setModalContent(error?.response?.data?.message);
                setModalAction(() => () => (window.location.href = '/login'));
                setSaveStatus(false);
            }
        };

        if (Cookies.get('isLogin')) {
            axiosData();
        } else {
            setModalContent('로그인 후 이용 가능한 서비스 입니다.');
            setModalAction(() => () => (window.location.href = '/login'));
            setSaveStatus(false);
        }
    }, []);

    const requestDelete = async () => {
        try {
            const hostname = window.location.hostname;
                let isLocal = null;
                if (hostname === 'wpal.philippineair.co.kr') {
                    isLocal = true;
                } else {
                    isLocal = false;
                }

            const seq = window.location.search.split('=')[1];
            const response = await axios.post(
                `${
                    isLocal
                        ? process.env.REACT_APP_PRODUCTION_API_URL
                        : process.env.REACT_APP_LOCAL_API_URL
                }/wpal/board/scTicket/delete/${seq}`,
                {},
                {
                    withCredentials: true,
                },
            );

            if (response.data.rowsAffected[0] === 1) {
                setModalContent('삭제 완료되었습니다.');
                setModalAction(() => () => window.location.href = '/service/scTicketlist');
                setSaveStatus(false);
            }
        } catch (error) {
            setModalContent('삭제 요청중 오류가 발생했습니다.');
            setModalAction(() => () => setSaveStatus(true));
            setSaveStatus(false);
        }
    };

    return (
        <div className='bodyContainer '>
            <div class='subp_h_wrap'>
                <div class='subp_h_list subp_h_home'>
                    <div>서비스요청</div>
                    <div>AUTO REISSUE - SC 티켓 발송요청</div>
                    <div>요청 내역 확인</div>
                </div>
            </div>
            <div className='wpal-contents' id='contents'>
                <div className='mypageFromWrap'>
                    <div className='page_hgroup'>
                        <h2 className='title'>AUTO REISSUE - SC 티켓 발송요청 상세</h2>
                    </div>
                    <div className='agentCheckWrap'>
                        <h4>요청 내용</h4>

                        <table className='mypage-table'>
                            <tbody>
                                <tr className='firstTable-border'>
                                    <th>담당자</th>
                                    <td>
                                        <div className='table-padding wpal-divWeight' id='name'>
                                            {detailData.regAgtName}
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <th>휴대폰번호</th>
                                    <td>
                                        <div
                                            className='table-padding wpal-divWeight'
                                            id='userPhone'
                                        >
                                            {detailData.regAgtPhone}
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className='agentCheckWrap'>
                        <h4>PNR 1</h4>

                        <table className='mypage-table'>
                            <tbody>
                                <tr className='firstTable-border'>
                                    <th>항공사 예약번호</th>
                                    <td>
                                        <div className='table-padding wpal-divWeight' id='name'>
                                            {detailData.air_pnr}
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <th>티켓번호</th>
                                    <td>
                                        <div className='table-padding wpal-divWeight' id='name'>
                                            {detailData.tkt_number}
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <th>티켓 수신 이메일 주소</th>
                                    <td>
                                        <div
                                            className='table-padding wpal-divWeight'
                                            id='userPhone'
                                        >
                                            {detailData.tkt_email_address}
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <th>비고</th>
                                    <td colSpan={3}>
                                        <div
                                            className='table-padding wpal-divWeight wpal-remark'
                                            id='userPhone'
                                        >
                                            {detailData.freeMemo}
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className='agentInfo'>
                        <h4>처리 결과</h4>

                        <table className='mypage-table'>
                            <tbody>
                                <tr className='firstTable-border'>
                                    <th>상태</th>
                                    <td>
                                        <div
                                            className='table-padding wpal-divWeight wpal-textcolor'
                                            id='status'
                                        >
                                            {status[detailData.status]}
                                        </div>
                                    </td>
                                </tr>
                            <tr>
                                    <th>항공사 비고</th>
                                    <td>
                                        <div className='table-padding wpal-divWeight wpal-remark'>
                                            {detailData.status_other_reason == 'null'
                                                ? ''
                                                : detailData.status_other_reason}
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    {status[detailData.status] === '요청중' ? (
                    <div className='submitArea' style={{ display: 'flex', gap: '75px' }}>
                        <input
                            class={`each-button`}
                            type='button'
                            value='삭제하기'
                            onClick={() => requestDelete()}
                        />                        
                    </div>
                    ) : (
                        <></>
                    )}
                </div>
            </div>
            <SaveModal content={modalContent} SaveBtn={saveStatus} onClose={modalAction} />
        </div>
    );
}

export default ScTicketDetail;
